import { Suspense } from "react";
import { Canvas } from "@react-three/fiber";
import { Environment } from "@react-three/drei";
import hdr from "../../assets/images/Refine4.hdr";
import ToyotaCrownShowroomModel from "./ToyotaCrownShowroomModel";

export default function PreviewCanvas({ model }) {
  return (
    <Canvas
      dpr={[1, 1.5]}
      gl={{ antialias: true, alpha: true }}
      camera={{ position: [0, 1.4, 7.4], fov: 28, near: 0.1, far: 200 }}
      style={{ position: "absolute", inset: 0 }}
    >
      <color attach="background" args={["#ffffff"]} />
      <fog attach="fog" args={["#ffffff", 12, 28]} />
      <ambientLight intensity={1.2} />
      <directionalLight intensity={1.9} position={[5, 8, 5]} />
      <directionalLight intensity={0.8} position={[-5, 4, -4]} />
      <Suspense fallback={null}>
        <Environment files={hdr} />
        <ToyotaCrownShowroomModel modelOverride={model} />
      </Suspense>
    </Canvas>
  );
}
